import IntlProvider from "./I18NProv";
import { connect } from "react-redux";
import IdleTimer from "react-idle-timer";
import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import BaseRoutes from "./routes/baseRoutes";
import { getCurrentEnvironment, isJWTSessionValid } from "./Redux/actions/env";
import { getEnvironment } from "./Redux/reducer/env";
import Footer from "./components/public/footer/footer";
import { getSessionInfo, getPage } from "./Redux/reducer/session";
import { logout } from "./Redux/actions/sessionActions";

export class App extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.tokenValidator = null;
  }

  componentDidMount() {
    const { getCurrentEnvironment } = this.props;
    const preloadedState = window.__PRELOADED_STATE__;

    if (undefined !== preloadedState) {
      getCurrentEnvironment(JSON.parse(preloadedState));
    }

    delete window.__PRELOADED_STATE__;
    this.enableInterval();
  }

  componentDidUpdate() {
    this.enableInterval();
  }

  enableInterval = () => {
    if (this.props.session.authenticated && this.tokenValidator === null) {
      // realizamos la primera llamada
      this.props.isJWTSessionValid(this.props.session.expiration);

      // Configuramos el interval
      this.tokenValidator = setInterval(() => {
        this.props.isJWTSessionValid(this.props.session.expiration);
      }, 1000 * 60 * 5);
    }
  };

  handleOnIdle = () => {
    // Cuando se cumple la inactividad, deslogueamos al usuario y limpiamos le interval
    clearInterval(this.tokenValidator);
    this.props.logout();
  };

  getIdleTimer() {
    return (
      this.props.session.authenticated && (
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref;
          }}
          timeout={1000 * 60 * 10}
          onIdle={this.handleOnIdle}
        />
      )
    );
  }

  render() {
    const { authenticated } = this.props.session;

    var wrapperClass = "";
    if (authenticated) {
      wrapperClass = "wrapper";
    } else {
      switch (this.props.page) {
        case "register":
          wrapperClass = "wrapper-register";
          break;
        case "bsc-login":
          wrapperClass = "wrapper-bsc-login";
          break;
        default:
          wrapperClass = "wrapper-front";
          break;
      }
    }

    return (
      <Router>
        {this.getIdleTimer()}
        <IntlProvider>
          <div className={wrapperClass}>
            <BaseRoutes />
            {authenticated !== true && <Footer />}
          </div>
        </IntlProvider>
      </Router>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    session: getSessionInfo(state),
    env: getEnvironment(state),
    page: getPage(state),
  };
};

export const mapDispatch = (dispatch) => ({
  getCurrentEnvironment: (payload) => dispatch(getCurrentEnvironment(payload)),
  isJWTSessionValid: (payload) => dispatch(isJWTSessionValid(payload)),
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatch)(App);
